
export default {
	props: {
		modalMenu: Boolean,
		likesArray: Array
	}
}
